import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

export const ContactBar = styled.div`
  display: flex;
  justify-content: center;
  background-color: black;
  color: white;

  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background-color: black;
    color: white;
    padding: 10px;
    padding-right: 100px;
    width: 100%;
  }
`;

export const ContactBarChild = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  &:hover {
    color: #de7b85;
  }
  cursor: pointer;
`;

export const HeaderLogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderLogo = styled.img`
  width: 200px;
`;

export const Navbar = styled.div`
  display: ${props => (props.showNav ? "inline-block" : "none")};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;

  @media screen and (min-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    margin-top: 0;
  }

  ${props =>
    props.showNav &&
    css`
      transform: translateY(0);

      @media screen and (min-width: 768px) {
        transform: translateX(0);
      }
    `}
`;

export const NavbarChild = styled.div`
  display: inline-block;
  padding: 1px;
  color:  rgb(70, 70, 70);
  text-align: center;
  cursor: pointer;
  &:hover {
    border-bottom: 3px solid blue;
    z-index: 2;
    color: blue;
  }
  margin: 5px ;

  @media screen and (min-width: 768px) {
    padding: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }
`;

export const HamburgerIcon = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: absolute;
    top: 50px;
    right: 30px;
    z-index: 2;
    cursor: pointer;

    ion-icon {
      font-size: 32px;
    }
    ${props =>
      props.showNav &&
      css`
        ion-icon {
          transform: rotate(90deg);
        }
      `}
  }
`;
